<h1 class="page-title">Product Catalog</h1>

<div class="main-content">
  <!-- Filter Panel -->
  <mat-card class="filter-panel">
    <div class="filter-grid">
      <!-- Search -->
      <mat-form-field appearance="outline" class="filter-item">
        <mat-label>Search Collections</mat-label>
        <input
          matInput
          [(ngModel)]="searchText"
          (ngModelChange)="filterCollections()"
          placeholder="Type to search..."
        />
      </mat-form-field>

      <!-- Source Filter -->
      <mat-form-field appearance="outline" class="filter-item">
        <mat-label>Filter by Source</mat-label>
        <mat-select [(ngModel)]="sourceFilter" (selectionChange)="onSourceFilterChange()">
          <mat-option value="all">All</mat-option>
          <mat-option value="iolr">Lake Kinneret</mat-option>
          <mat-option value="med">Mediterranean Sea</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-card>

  <!-- No results -->
  <div *ngIf="!loading && filteredCollections.length === 0" class="no-results">
    <p>No collections found. Try changing your filters or search term.</p>
  </div>

  <!-- Cards Grid -->
  <div class="card-grid">
    <mat-card class="example-card" appearance="outlined" *ngFor="let collection of filteredCollections">
      <mat-chip-list>
        <mat-chip [class]="collection.is_med ? 'mediterranean-sea-chip' : 'lake-kinneret-chip'" selected>
          {{ collection.is_med ? 'Mediterranean Sea' : 'Lake Kinneret' }}
        </mat-chip>
      </mat-chip-list>

      <mat-card-header>
        <mat-card-title>{{ collection.public_title }}</mat-card-title>
        <mat-card-subtitle>{{ collection.title }}</mat-card-subtitle>
      </mat-card-header>

      <mat-card-actions>
        <a mat-button color="primary" [routerLink]="['/product-page', collection._id]">Learn More</a>
      </mat-card-actions>
    </mat-card>
  </div>

  <app-loading-spinner *ngIf="loading"></app-loading-spinner>
</div>
